"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSiteSettingsByDomain = exports.getAllDomainsSiteSettings = exports.getSiteSettings = exports.getSaveSiteSettingsChangesRequestStatus = exports.getFetchSiteSettingsRequestStatus = void 0;

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _constants = require("./constants");

var getFetchSiteSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.SiteSettingsActionTypes.FETCH_SITE_SETTINGS);
exports.getFetchSiteSettingsRequestStatus = getFetchSiteSettingsRequestStatus;
var getSaveSiteSettingsChangesRequestStatus = (0, _getRequestStatus.default)(_actions.SiteSettingsActionTypes.SAVE_SITE_SETTINGS_CHANGES);
exports.getSaveSiteSettingsChangesRequestStatus = getSaveSiteSettingsChangesRequestStatus;

var getSiteSettings = function getSiteSettings(state) {
  return state.siteSettings;
};

exports.getSiteSettings = getSiteSettings;

var getAllDomainsSiteSettings = function getAllDomainsSiteSettings(state) {
  return getSiteSettings(state).get(_constants.ALL_DOMAINS_KEY);
};

exports.getAllDomainsSiteSettings = getAllDomainsSiteSettings;

var getSiteSettingsByDomain = function getSiteSettingsByDomain(state, domainName) {
  return getSiteSettings(state).getIn(['byDomain', domainName]);
};

exports.getSiteSettingsByDomain = getSiteSettingsByDomain;